<template>
	<div class="legitimation-resend">
		<template v-if="!requestedCode">
			<Phone
				v-if="typeMobilePhone && changable"
				v-model="phoneNumber"
				:meta="meta"
				class="mb-3"
			/>
			<div v-if="typeMobilePhone && !changable" class="legitimation-resend--show">{{ phone.formatted }}</div>
			<div v-if="typeEmail">
				Wir senden dir eine E-Mail mit einem Code zur Bestätigung zu.
			</div>
			<div v-if="typeMobilePhone">
				Wir senden dir eine SMS mit einem Code zur Bestätigung zu.
			</div>
			<div class="mt-3">
				<Button
					text="Code anfordern"
					icon="checkmark"
					:disabled="!preCodeRequestDataValid || requestingCode"
					:loading="requestingCode"
					@click="requestCode"
				/>
			</div>
		</template>
		<template v-else>
			<FormGroup label="Code">
				<div class="d-flex align-items-center">
					<b-input v-model.trim="code" type="text" style="width: 10rem" @keyup.enter="submitCode"/>
					<Button
						class="ml-2"
						icon="checkmark"
						text="Code bestätigen"
						:disabled="!canSubmitCode"
						:loading="submittingCode"
						@click="submitCode"
					/>
					<div v-if="submittingError" class="error ml-2">Code ungültig</div>
				</div>
			</FormGroup>
		</template>
	</div>
</template>

<script>
import Button from "@/vue/common/Button";
import Loading from "@/vue/common/Loading";
import FormGroup from "@/vue/common/form/Group";
import {isEmptyOrNull} from "@/helper/String";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import {isDefined} from "@/helper/Value";
import Phone from "@/vue/common/form/Phone";
import {mapState} from "vuex";

const TYPE_EMAIL = 'email';
const TYPE_MOBILE_PHONE = 'mobilePhone';

export default {

	components: {
		Loading,
		Button,
		FormGroup,
		Phone,
	},

	props: {
		type: {
			type: String,
			required: true,
		},
		resendFunction: {
			type: Function,
			required: true,
		},
		changeFunction: {
			type: Function,
			required: true,
		},
		phone: {
			type: Object,
			required: false,
		},
		changable: {
			type: Boolean,
			required: false,
			default: true,
		},
	},

	data ()
	{
		return {
			requestingCode: false,
			requestedCode: false,
			phoneNumber: this.phone,
			code: '',
			submittingCode: false,
			submittingError: false,
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		mustAddPhoneNumber ()
		{
			return this.typeMobilePhone && !isDefined(this.phone);
		},
		phoneNumberValid ()
		{
			return !this.mustAddPhoneNumber || isDefined(this.phoneNumber);
		},
		preCodeRequestDataValid ()
		{
			return this.phoneNumberValid;
		},
		typeEmail ()
		{
			return this.type === TYPE_EMAIL;
		},
		typeMobilePhone ()
		{
			return this.type === TYPE_MOBILE_PHONE;
		},
		codeValid ()
		{
			return !isEmptyOrNull(this.code);
		},
		canSubmitCode ()
		{
			return this.codeValid && !this.submittingCode;
		}
	},

	methods: {
		async requestCode ()
		{
			this.requestingCode = true;

			try
			{
				await this.resendFunction({
					type: this.type,
					phoneNumber: this.mustAddPhoneNumber
						? this.phoneNumber
						: undefined
				});

				this.requestedCode = true;
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.requestingCode = false;
		},
		async submitCode ()
		{
			if (!this.canSubmitCode)
			{
				return;
			}

			this.submittingCode = true;

			try
			{
				await this.changeFunction({
					type: this.type,
					code: this.code,
				});

				this.$emit('success');

				this.submittingError = false;
			}
			catch (e)
			{
				this.submittingError = true;
			}

			this.submittingCode = false;
		}
	}
}
</script>
